import { getBranchNameById } from "../config/branches";
import { PrintInfo } from "../types/misa";
import { numberToVietnameseText } from "./numberToVietnameseText";

export const generatePrintHTMLNhapHang = (data: PrintInfo): string => {
  if (!data) return "";
  const { header, details, skuLocations, inventorries } = data;

  const totalAmount = details.reduce((sum, d) => sum + (d.Amount || 0), 0);
  const totalDiscount = details.reduce(
    (sum, d) => sum + (d.DiscountAmount || 0),
    0
  );
  const totalVAT = details.reduce((sum, d) => sum + (d.VATAmount || 0), 0);
  const totalPayment = totalAmount - totalDiscount + totalVAT;

  return `<!DOCTYPE html><html><head><meta charset="utf-8" />
  <title>Phiếu nhập hàng - ${header.RefNo}</title>
  <style>
    @page { size: A4 landscape; margin: 15mm; }
    body { font-family: "Times New Roman", serif; font-size:12px; line-height:1.4; margin:0; padding:10px; color:#000; }
    .header { text-align:center; margin-bottom:20px; }
    .company-info { text-align:left; margin-bottom:10px; }
    .title { font-size:18px; font-weight:bold; margin:15px 0; }
    table { width:100%; border-collapse:collapse; margin:15px 0; }
    th, td { border:1px solid #000; padding:2px 4px; text-align:center; vertical-align:middle; }
    th { background:#f5f5f5; font-weight:bold; }
    .text-left { text-align:left; } .text-right { text-align:right; } .text-center { text-align:center; }
    .total-row { font-weight:bold; }
    
    /* Footer: ngày tháng + chữ ký luôn đi cùng nhau */
    .footer-wrapper { page-break-inside: avoid; page-break-before: avoid; }
    .footer-date { page-break-inside: avoid; margin-bottom: 15px; text-align: right; }
    .footer { margin-top:10px; display:flex; justify-content:space-between; page-break-inside: avoid; }
    .signature-section { text-align:center; width:30%; page-break-inside: avoid; }
    .signature-title { font-weight:bold; margin-bottom:5px; }
    .signature-note { font-style:italic; margin-bottom:80px; }
    
    .money-text { margin:15px 0; font-style:italic; page-break-inside: avoid; }
    @media print { body { print-color-adjust: exact; -webkit-print-color-adjust: exact; } }
  </style></head><body>
  <div class="company-info"><strong>CÔNG TY CỔ PHẦN LIÊN KẾT NHÀ THUỐC PHARCECO</strong><br/><strong>Địa chỉ: </strong> Thôn Bá Khê, Xã Văn Giang, Tỉnh Hưng Yên<br/><strong>MST: </strong>0901155224</div>
  <div class="header"><div class="title">PHIẾU NHẬP HÀNG</div>
    <div class="date-info"><em><strong>Ngày ${
      header.RefDate ? new Date(header.RefDate).toLocaleDateString("vi-VN") : ""
    } </strong></em><br/><strong>Số: ${header.RefNo || ""}</strong></div>
  </div>
  <div class="info-row" style="margin-bottom: 5px"><span class="info-label"><strong>Nhà cung cấp: </strong></span> ${
    header.VendorName || ""
  }</div>
  <div class="info-row" style="margin-bottom: 5px"><span class="info-label"><strong>Diễn giải:</strong></span> ${
    header.JournalMemo || ""
  }</div>
  <div class="info-row" style="margin-bottom: 5px"><span class="info-label"><strong>Kho nhập: </strong></span>${
    header.BranchID
      ? getBranchNameById(header.BranchID)
      : header.BranchName || ""
  }</div>
  <table><thead><tr>
    <th rowspan="2" style="width:40px;">STT</th><th rowspan="2" style="width:100px;">Mã SKU</th><th rowspan="2" style="width:80px;">Barcode</th><th rowspan="2" style="width:100px;">Vị trí</th><th rowspan="2" style="width:320px;">Tên hàng hóa</th><th rowspan="2" style="width:80px;">Lô</th><th rowspan="2" style="width:80px;">Hạn dùng</th><th rowspan="2" style="width:50px;">ĐVT</th><th rowspan="2" style="width:50px;">SL</th><th rowspan="2" style="width:80px;">Đơn giá</th><th rowspan="2" style="width:100px;">Thành tiền</th><th rowspan="2" style="width:60px;">%CK</th><th rowspan="2" style="width:100px;">Thuế suất</th><th colspan="2" style="width:150px;">Cảm quan</th>
  </tr>
  <tr>
    <th style="width:60px;">Đạt</th><th style="width:90px;">Không đạt</th>
  </tr></thead><tbody>
  ${details
    .map(
      (item, i) => `<tr>
      <td>${i + 1}</td>
      <td class="text-left">${item.SKUCode || ""}</td>
      <td class="text-left">${
        inventorries?.find((inv) => inv.SKUCode === item.SKUCode)?.Barcode || ""
      }</td>
      <td>${skuLocations?.get(item.SKUCode || "") || ""}</td>
      <td class="text-left">${item.InventoryItemName || ""}</td>
      <td>${item.LotNo || ""}</td>
      <td>${
        item.ExpiryDate
          ? new Date(item.ExpiryDate).toLocaleDateString("vi-VN")
          : ""
      }</td>
      <td>${item.UnitName || "Hộp"}</td>
      <td class="text-right">${item.Quantity || 0}</td>
      <td class="text-right">${
        item.UnitPrice ? Number(item.UnitPrice).toLocaleString("vi-VN") : 0
      }</td>
      <td class="text-right">${
        item.Amount ? Number(item.Amount).toLocaleString("vi-VN") : 0
      }</td>
      <td class="text-right">${item.DiscountRate || 0}</td>
      <td class="text-right">${item.VATRate || 0}</td>
      <td></td><td></td>
    </tr>`
    )
    .join("")}
  <tr class="total-row"><td colspan="10" class="text-left"><strong>Cộng tiền hàng</strong></td><td colspan="3" class="text-right"><strong>${totalAmount.toLocaleString(
    "vi-VN"
  )}</strong></td><td></td><td></td></tr>
  <tr class="total-row"><td colspan="10" class="text-left"><strong>Tiền thuế GTGT</strong></td><td colspan="3" class="text-right"><strong>${totalVAT.toLocaleString(
    "vi-VN"
  )}</strong></td><td></td><td></td></tr>
  <tr class="total-row"><td colspan="10" class="text-left"><strong>Tiền chiết khấu</strong></td><td colspan="3" class="text-right"><strong>${totalDiscount.toLocaleString(
    "vi-VN"
  )}</strong></td><td></td><td></td></tr>
  <tr class="total-row"><td colspan="10" class="text-left"><strong>Tổng tiền thanh toán</strong></td><td colspan="3" class="text-right"><strong>${totalPayment.toLocaleString(
    "vi-VN"
  )}</strong></td><td></td><td></td></tr>
  </tbody></table>
  <div class="money-text"><strong>Số tiền viết bằng chữ:</strong> <em>${numberToVietnameseText(
    totalPayment
  )}</em></div>
  
  <div class="footer-wrapper">
    <div class="footer-date"><em>Ngày .... tháng .... năm ...........</em></div>
    <div class="footer">
      ${[
        "Người chịu trách nhiệm chuyên môn",
        "Thủ kho nhập",
        "Kế toán trưởng",
        "Người lập phiếu",
      ]
        .map(
          (title) =>
            `<div class="signature-section"><div class="signature-title">${title}</div><div class="signature-note">(Ký, họ tên)</div></div>`
        )
        .join("")}
    </div>
  </div>
  </body></html>`;
};
